import { HugeiconsIcon } from '@hugeicons/react';
import type { CSSProperties } from 'react';
import type { HugeIconProps } from './HugeIcon.types';

export type { HugeIconData, HugeIconProps } from './HugeIcon.types';

export function HugeIcon({
  icon,
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  decorative = true,
  spin = false,
  className,
  style,
  accessibilityLabel,
  ...accessibilityProps
}: HugeIconProps) {
  return (
    <HugeiconsIcon
      icon={icon}
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      aria-hidden={decorative || undefined}
      aria-label={decorative ? undefined : accessibilityLabel}
      focusable="false"
      className={[className, spin ? 'animate-spin' : null].filter(Boolean).join(' ') || undefined}
      style={style as CSSProperties}
      {...accessibilityProps}
    />
  );
}
